var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgResume = function SvgResume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7 10l2.61 2.61a.1.1 0 00.158-.022L12.865 7"
  }))));
};
export default SvgResume;